import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Grid, Affix, Drawer } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import TrainingMarquee from "../components/TrainingAnnouncement/TrainingMarquee";
import { useAppSelector } from "store";

const { Header: AntHeader, Content, Sider } = Layout;

const { useBreakpoint } = Grid;

interface MainProps {
  children: JSX.Element;
  namePage?: string;
  subNamePage?: string;
  showHeader?: boolean;
  footerComponent?: JSX.Element | null;
}

const ProductLayout: FC<MainProps> = ({
  children,
  namePage,
  footerComponent,
}) => {
  const { footerShow } = useAppSelector((state) => state.layout);

  const screens = useBreakpoint();
  const sidenavColor = "#1890ff";
  const sidenavType = "#fff";
  const fixed = false;

  const [open, setOpen] = useState(false);

  const openDrawer = () => setOpen(!open);

  useEffect(() => {
    if (screens.md) {
      setOpen(false);
    }
  }, [screens]);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  return (
    <Layout
      className={`layout-dashboard ${pathname === "profile" ? "layout-profile" : ""
        } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
    >
      <Drawer
        title={false}
        placement="left"
        closable={false}
        onClose={() => setOpen(false)}
        open={open}
        key="left"
        width={250}
      >
        <Layout className={`layout-dashboard layout-dashboard-rtl}`}>
          <Sider
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary ${sidenavType === "#fff" ? "active-route" : ""
              }`}
            style={{ background: sidenavType }}
          >
            <Sidenav color={sidenavColor} />
          </Sider>
        </Layout>
      </Drawer>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(collapsed, type) => {
          // console.log(collapsed, type);
          // setResponsive(collapsed);
        }}
        width={250}
        theme="light"
        className={`sider-primary ant-layout-sider-primary ${sidenavType === "#fff" ? "active-route" : ""
          }`}
        style={{ background: sidenavType, borderRadius: "12px 12px 0px 0px" }}
      >
        <Sidenav color={sidenavColor} />
      </Sider>
      <Layout>
        <Affix>
          <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
            <Header name={namePage} onPress={openDrawer} />
          </AntHeader>
        </Affix>

        {/* ป้ายเชิญอบรม — คืน null เองเมื่อไม่ใช่ role factory / ไม่มีอบรม / ผู้ใช้กดปิด */}
        <TrainingMarquee />

        <Content className="content-ant">{children}</Content>
        <Affix offsetBottom={0}>
          <AntHeader>{footerComponent}</AntHeader>
        </Affix>
      </Layout>
    </Layout>
  );
};

export default ProductLayout;
